import apiClient, { API_ENDPOINTS, rejectWithError } from "api";
import {
    buildCareerApplicationPayload,
    buildCareerResumeUploadFormData,
    buildPublishedCareerCriteria
} from "domains/career/services/careerRequestBuilders";

const { career, upload } = API_ENDPOINTS;

const normalizeCareerList = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.careers)) return payload.careers;
    return [];
};

const rejectCareerError = (error, label) => rejectWithError(error, label);

export const findCareersByCriteria = async (criteria = {}) => {
    try {
        const data = await apiClient.post(career.findByCriteria, criteria);
        return normalizeCareerList(data);
    } catch (error) {
        return rejectCareerError(error, "Error finding careers");
    }
};

export const findPublishedCareersByCompany = async (companyId) => {
    if (!companyId) return [];
    return findCareersByCriteria(buildPublishedCareerCriteria(companyId));
};

export const uploadCareerResume = async (resumeFile, companyId) => {
    if (!companyId) {
        throw new Error("Company is required to upload resume");
    }

    try {
        return await apiClient.upload(upload.uploadImage, buildCareerResumeUploadFormData(resumeFile, companyId), {
            responseType: "text"
        });
    } catch (error) {
        return rejectCareerError(error, "Error uploading career resume");
    }
};

export const submitCareerApplication = async (applicationPayload) => {
    try {
        const data = await apiClient.post(career.apply, applicationPayload);
        return data?.data || data;
    } catch (error) {
        return rejectCareerError(error, "Error submitting career application");
    }
};

export const applyForCareer = async (application = {}, resumeFile) => {
    if (!resumeFile) {
        throw new Error("Resume is required");
    }

    const companyId = application.company?.primaryId || application.companyId;
    const resumeObjectKey = await uploadCareerResume(resumeFile, companyId);
    const payload = buildCareerApplicationPayload({
        ...application,
        resumeObjectKey,
        resumeUrl: resumeObjectKey,
        resumeFileName: resumeFile.name,
        resumeContentType: resumeFile.type,
        resumeSize: resumeFile.size,
    });

    return submitCareerApplication(payload);
};
